import { useEffect, useRef } from 'react'
import { usePostHog } from '@posthog/react'
import { useSessionStore } from '@/features/session/model/sessionStore'
import { isScreenshotFixtureMode } from '@/shared/lib/screenshotMode'

/**
 * Associa utilizador autenticado ao distinct id (UUID Supabase), sem enviar email/nome (alinhado ao Sentry).
 */
export function PosthogIdentitySync() {
  const posthog = usePostHog()
  const user = useSessionStore((s) => s.user)
  const sessionRestored = useSessionStore((s) => s.sessionRestored)
  const lastIdentifiedProps = useRef<string | null>(null)

  useEffect(() => {
    if (!sessionRestored || isScreenshotFixtureMode()) return

    if (!user) {
      if (lastIdentifiedProps.current !== null) {
        posthog.reset()
        lastIdentifiedProps.current = null
      }
      return
    }

    const payloadKey = JSON.stringify({
      id: user.id,
      role: user.role,
      is_system_admin: Boolean(user.isSystemAdmin),
    })
    if (lastIdentifiedProps.current === payloadKey) return

    lastIdentifiedProps.current = payloadKey
    posthog.identify(user.id, {
      role: user.role,
      is_system_admin: user.isSystemAdmin,
    })
  }, [posthog, sessionRestored, user])

  return null
}
